/* Luca Bianchi theme · interazioni minime, JavaScript senza librerie.
   Round 84 (tema v28): galleria prodotto funzionante, menu mobile chiudibile anche con Esc,
   contatori del carrello sempre aggiornati, niente aggiunta "silenziosa" nella pagina carrello,
   avviso di aggiunta che non copre più il banner dei cookie. */
(function(){
  var body = document.body;

  // ---------- Menu mobile ----------
  var burger = document.querySelector('[data-burger]'),
      drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    var isOpen = function(){ return drawer.classList.contains('open'); };
    var openD = function(){
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      body.style.overflow = 'hidden';
      var c = drawer.querySelector('[data-close]');
      if (c) { setTimeout(function(){ try { c.focus({ preventScroll: true }); } catch (e) { c.focus(); } }, 80); }
    };
    var closeD = function(returnFocus){
      if (!isOpen()) { return; }
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      body.style.overflow = '';
      if (returnFocus) { burger.focus(); }
    };
    burger.addEventListener('click', openD);
    drawer.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click', function(){ closeD(true); }); });
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ closeD(false); }); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeD(true); } });
    window.addEventListener('pageshow', function(){ closeD(false); body.style.overflow = ''; });
  }

  // ---------- Comparsa delle sezioni allo scorrimento ----------
  var reveals = document.querySelectorAll('.lb-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.01, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function(el){ io.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('in'); });
  }

  // ---------- Galleria prodotto ----------
  var main = document.querySelector('[data-pdp-main]');
  if (main) {
    var thumbs = document.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        if (t.dataset.srcset) { main.srcset = t.dataset.srcset; }
        if (t.dataset.src) { main.src = t.dataset.src; }
        if (t.dataset.alt) { main.alt = t.dataset.alt; }
        thumbs.forEach(function(o){
          o.classList.toggle('is-active', o === t);
          o.setAttribute('aria-pressed', o === t ? 'true' : 'false');
        });
      });
    });
  }

  // ---------- Variante: aggiorna prezzo e disponibilità ----------
  var vsel = document.querySelector('[data-variant-select]');
  if (vsel) {
    vsel.addEventListener('change', function(){
      var opt = vsel.options[vsel.selectedIndex];
      var priceEl = document.querySelector('[data-price-value]');
      if (priceEl && opt.dataset.price) { priceEl.textContent = opt.dataset.price; }
      var unitEl = document.querySelector('[data-unit-price]');
      if (unitEl) { if (opt.dataset.unit) { unitEl.textContent = opt.dataset.unit; unitEl.hidden = false; } else { unitEl.hidden = true; } }
      var submit = document.querySelector('#lb-pdp-form [name="add"]');
      if (submit) {
        var ok = opt.dataset.available === 'true';
        submit.disabled = !ok;
        submit.innerHTML = ok ? 'Aggiungi al carrello <span class="lb-arr">→</span>' : 'Esaurito';
      }
    });
  }

  // ---------- Selettori quantità ----------
  document.querySelectorAll('[data-qty]').forEach(function(box){
    var input = box.querySelector('input');
    if (!input) { return; }
    box.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        var v = parseInt(input.value || '1', 10);
        if (isNaN(v)) { v = 1; }
        v = (b.dataset.step === 'down') ? Math.max(parseInt(input.min || '1', 10), v - 1) : v + 1;
        input.value = v;
        if (input.dataset.autosubmit && input.form) {
          if (input.form.requestSubmit) { input.form.requestSubmit(); } else { input.form.submit(); }
        }
      });
    });
  });

  // ---------- Avviso (toast) ----------
  var toast = document.querySelector('[data-toast]'), toastTimer;
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function showToast(html){
    if (!toast) { return; }
    toast.innerHTML = html;
    var bn = document.querySelector('[data-cookie-banner]');
    toast.style.bottom = (bn && !bn.hidden) ? (bn.offsetHeight + 16) + 'px' : '';
    toast.hidden = false;
    requestAnimationFrame(function(){ toast.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){
      toast.classList.remove('show');
      setTimeout(function(){ toast.hidden = true; }, 350);
    }, 4200);
  }

  // ---------- Carrello: aggiunta senza lasciare la pagina ----------
  function refreshCartCount(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var n = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; el.hidden = n === 0; });
        document.querySelectorAll('[data-cart-count-plain]').forEach(function(el){ el.textContent = n; });
        document.querySelectorAll('[data-cart-link]').forEach(function(el){ el.setAttribute('aria-label', 'Carrello, ' + n + (n === 1 ? ' articolo' : ' articoli')); });
      }).catch(function(){});
  }
  var onCartPage = body.classList.contains('template-cart');
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    // Nella pagina carrello si usa l'invio classico: la pagina si ricarica già aggiornata.
    if (onCartPage) { return; }
    var ajaxOff = false;
    form.addEventListener('submit', function(e){
      if (ajaxOff || !window.fetch) { return; }
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var old = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Un attimo…'; }
      var restore = function(){ if (btn) { btn.disabled = false; btn.innerHTML = old; } };
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function(r){
          if (!r.ok) { return r.json().then(function(d){ throw d; }); }
          return r.json();
        })
        .then(function(item){
          restore();
          refreshCartCount();
          showToast('<b>' + esc(item.product_title || 'Prodotto') + '</b> aggiunto al carrello. <a href="/cart">Vai al carrello →</a>');
        })
        .catch(function(err){
          restore();
          if (err && err.description) { showToast(esc(err.description)); }
          else { ajaxOff = true; form.submit(); }
        });
    });
  });

  // ---------- Banner cookie (API Customer Privacy di Shopify) ----------
  var banner = document.querySelector('[data-cookie-banner]');
  function showBanner(){ if (banner) { banner.hidden = false; } }
  function hideBanner(){ if (banner) { banner.hidden = true; } }
  // La scelta locale scade dopo 180 giorni (Linee guida cookie del Garante: non richiedere di nuovo il consenso prima di 6 mesi).
  var CHOICE_TTL = 180 * 24 * 60 * 60 * 1000;
  function localChoice(){
    try {
      var raw = localStorage.getItem('lb-cookie-choice');
      if (!raw) { return null; }
      var parts = raw.split('|');
      var ts = parseInt(parts[1], 10);
      if (!ts || (Date.now() - ts) > CHOICE_TTL) { localStorage.removeItem('lb-cookie-choice'); return null; }
      return parts[0];
    } catch (e) { return null; }
  }
  function setLocalChoice(v){ try { localStorage.setItem('lb-cookie-choice', v + '|' + Date.now()); } catch (e) {} }

  function applyConsent(granted){
    var done = function(){ setLocalChoice(granted ? 'granted' : 'denied'); hideBanner(); };
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && api.setTrackingConsent) {
      try {
        api.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted }, done);
      } catch (e) {
        try { api.setTrackingConsent(granted, done); } catch (e2) { done(); }
      }
    } else { done(); }
  }

  function initConsent(forceShow){
    if (!banner) { return; }
    var boot = function(){
      if (forceShow) { showBanner(); return; }
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (api) {
        var should = false;
        try {
          if (api.shouldShowBanner) { should = api.shouldShowBanner(); }
          else if (api.shouldShowGDPRBanner) { should = api.shouldShowGDPRBanner(); }
          else { should = !localChoice(); }
        } catch (e) { should = !localChoice(); }
        if (should && !localChoice()) { showBanner(); }
      } else if (!localChoice()) {
        showBanner();
      }
    };
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(){ boot(); });
    } else { boot(); }
  }
  if (banner) {
    var acc = banner.querySelector('[data-cookie-accept]'), dec = banner.querySelector('[data-cookie-decline]');
    if (acc) { acc.addEventListener('click', function(){ applyConsent(true); }); }
    if (dec) { dec.addEventListener('click', function(){ applyConsent(false); }); }
    initConsent(false);
  }
  document.querySelectorAll('[data-cookie-prefs]').forEach(function(b){
    b.addEventListener('click', function(){ initConsent(true); });
  });
})();
